import React from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import Maybe from 'react-maybe';
import PropTypes from 'prop-types';

function MenuItemBody({ className, isActive, url, handleClick, children }) {
    return (
        <li className={cx(className, { [`${className}--active`]: isActive })}>
            <Maybe
                of={Boolean(url.length)}
                either={(
                    <Maybe
                        of={url.startsWith('http')}
                        either={(
                            <a
                                href={url} className={`${className}-body`} target="_blank"
                                rel="noopener noreferrer"
                                onClick={handleClick}
                            >
                                {children}
                            </a>
                        )}
                        orElse={(
                            <Link className={`${className}-body`} to={url} onClick={handleClick}>
                                {children}
                            </Link>
                        )}
                    />
                )}
                orElse={(
                    <span className={`${className}-body`} onClick={handleClick}>
                        {children}
                    </span>
                )}
            />
        </li>
    );
}
MenuItemBody.propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    url: PropTypes.string,
    handleClick: PropTypes.func
};
MenuItemBody.defaultProps = {
    className: 'menu__item',
    isActive: false,
    url: '',
    handleClick: () => null
};
export default MenuItemBody;
